import {
  Box,
  Button,
  Container,
  Paper,
  Grid,
  TextField,
  InputAdornment,
  IconButton,
  FormControl,
  InputLabel,
  OutlinedInput,
  CircularProgress,
  Typography,
} from '@mui/material';
import Logo from '@assets/auth/logo.svg';
import PryDataLogo from '@assets/global/logoprydata.svg';
import { useTranslation } from 'react-i18next';
import { LanguageMenu } from '@/components/atoms';
import { useState } from 'react';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import API from '@/apps/auth/services/login';
import { storeUser } from '@/services/storage';
import { ACTIONS, useAuth } from '@/contexts/auth';
import { useNavigate } from 'react-router';

export default function SignInPage() {
  const { t } = useTranslation();
  const [showPassword, setShowPassword] = useState(false);
  const { dispatch } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleLogin = async () => {
    try {
      setLoading(true);
      const response = await API.login({
        email: email,
        password: password,
      });
      console.log('Login successful:', response);
      await storeUser(response.data);
      dispatch({
        type: ACTIONS.LOGIN,
        user: response.data,
      });
      setLoading(false);
      navigate('/');
    } catch (error) {
      let message = 'Unknown error';
      if (error && typeof error === 'object') {
        if (
          'response' in error &&
          typeof error.response === 'object' &&
          error.response &&
          'data' in error.response
        ) {
          const data = error.response.data;
          // @ts-expect-error temp
          if (data?.non_field_errors && Array.isArray(data.non_field_errors)) {
            // @ts-expect-error temp
            message = data.non_field_errors[0];
          } else if (typeof data === 'string') {
            message = data;
          }
        } else if ('message' in error) {
          // @ts-expect-error temp
          message = error.message;
        }
      }
      setError(message);
      setLoading(false);
    }
  };

  return (
    <Box sx={{ bgcolor: '#C3CADB', minHeight: '100vh', display: 'flex' }}>
      <Container
        maxWidth="sm"
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '100%',
        }}
      >
        <Paper
          elevation={3}
          sx={{
            p: 5,
            borderRadius: 4,
            maxWidth: 400,
            width: '100%',
          }}
        >
          <Box display="flex" justifyContent="space-between" mb={8}>
            <LanguageMenu />
            <img src={Logo} alt="Prysmian Logo" height={25} />
          </Box>
          <Box display="flex" justifyContent="center" mb={3}>
            <img src={PryDataLogo} title="PryData" height={63} />
          </Box>

          <Grid
            container
            spacing={2}
            alignItems="center"
            justifyContent="center"
          >
            <Grid size={12} mt={3}>
              <TextField
                label={t('Email')}
                variant="outlined"
                fullWidth
                onChange={(e) => setEmail(e.target.value)}
                value={email}
                disabled={loading}
              />
            </Grid>
            <Grid size={12}>
              <FormControl fullWidth variant="outlined">
                <InputLabel>{t('Password')}</InputLabel>
                <OutlinedInput
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  type={showPassword ? 'text' : 'password'}
                  fullWidth
                  disabled={loading}
                  endAdornment={
                    <InputAdornment position="end">
                      <IconButton
                        onClick={() => setShowPassword(!showPassword)}
                        edge="end"
                      >
                        {showPassword ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    </InputAdornment>
                  }
                  label="Password"
                />
              </FormControl>
            </Grid>
            <Grid size={12} mt={2}>
              <Typography variant="body2" textAlign={'center'} color="error">
                {error}
              </Typography>
            </Grid>
          </Grid>

          <Button
            variant="gradient"
            onClick={() => handleLogin()}
            disabled={loading}
            fullWidth
            sx={{
              mt: 4,
              py: 1.5,
            }}
          >
            {loading ? <CircularProgress /> : t('Confirm')}
          </Button>
        </Paper>
      </Container>
    </Box>
  );
}

// import {

//     Button,
//     Container
// } from '@mui/material';

// import LanguageMenu from '@/components/languagemenu';

// export default function LoginPage() {

//     return (
//         <Container maxWidth="xs">
//             <Button
//                 type="button"
//                 fullWidth
//                 variant="contained"
//                 size="large"
//                 onClick={loginWithAzure}
//             >
//                 {'SSO'}
//             </Button>
//             <LanguageMenu />
//         </Container>
//     );
// }
